import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import MainContainer from "@pages/EverGreen/Components/Container";
import InnerContainer from "@pages/EverGreen/Components/InnerContainer";
import { ROUTE_PATH } from "@static/route-paths";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { LoadingScreen } from "@utils/helpers";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SourceOfWealth from "./sourceOfWealth";
import EmploymentDetail from "./employmentDetails";
import Button from "@pages/EverGreen/Components/Button";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import {
  PRODUCT_CODE_API,
  getNatureOfBusiness,
  getOccupations,
} from "@api/index";
import { useDispatch } from "react-redux";
import {
  IOccupationList,
  updateNatureOfBusinessList,
  updateOccupationList,
} from "@redux/slices/EVER_GREEN/step3Slice";
import { useAvivaSelector } from "@redux/hook";
import { isNonIncomerGroup } from "@pages/EverGreen/Helpers/helpers";
import { SCREEN_SIZE } from "@static/screen-size";
import { trackOnFormStartOrSuccess, trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

function Occupation() {
  const history = useHistory();
  const dispatch = useDispatch();
  const occupation = useAvivaSelector(
    (state) => state.everGreenStep3.occupation
  );
  const occupationList = useAvivaSelector(
    (state) => state.everGreenStep3.occupationList
  );
  const isMailingAddressUpdated = useAvivaSelector(
    (state) => state.everGreenStep2.isMailingAddressConfirmed
  );
  const [validataion, setValidation] = useState(false);
  useEffect(() => {
    async function fetchOccupation() {
      try {
        LoadingScreen(true);

        const { data } = await getOccupations("", PRODUCT_CODE_API.EVER_GREEN);
        const occupation = data.occupations as Array<{
          code: string;
          desc: string;
          status: string;
        }>;
        if (occupation?.length && occupation.length > 0) {
          const processedList: IOccupationList[] = [];
          occupation.forEach((val) => {
            if (val.status !== "Decline") {
              // { id: "Mr", label: "Mr" },
              processedList.push({
                id: val.code,
                label: val.desc,
                status: val.status,
              });
            }
          });
          dispatch(updateOccupationList(processedList));
        }
      } catch (e) {
        history.push(ROUTE_PATH.EVER_GREEN_CONTACTUS);
      } finally {
        LoadingScreen(false);
      }
    }

    //Check if the mailing address route was completed.

    //TODO fetch the Occupation drop down and nature of business list from backend.
    if (occupationList.length === 0) {
      fetchOccupation();
    }
  }, []);

  //TODO add validation to check the myinfo and mailing address are updated.

  useEffect(() => {
    // Check the occupation
    if (occupation.selectedOccupation.id !== "") {
      // Check if the income group
      if (isNonIncomerGroup(occupation.selectedOccupation.label)) {
        if (occupation.annualIncome.label === "") {
          setValidation(false);
          return;
        }
      } else {
        // eslint-disable-next-line no-mixed-operators
        if (
          ((occupation.annualIncome.label === "" ||
            occupation.employerName === "" ||
            occupation.natureOfBusiness.label === "" ||
            occupation.fcc === null) &&
            !isNonIncomerGroup(occupation.selectedOccupation.id)) ||
          occupation.annualIncome.label === ""
        ) {
          setValidation(false);
          return;
        }
      }
      if (
        occupation.natureOfBusiness.label.toLowerCase() === "others" &&
        occupation.natureOfBusinessContent === ""
      ) {
        setValidation(false);
        return;
      }
      // Source of wealth validation
      if (!Object.values(occupation.sourceOfWealth).some((x) => x)) {
        setValidation(false);
        return;
      }
      if (
        occupation.sourceOfWealth.Others &&
        occupation.sourceOfWealthOthersContent === ""
      ) {
        setValidation(false);
        return;
      }
      // Source of fund validation
      if (!Object.values(occupation.sourceOfFunds).some((x) => x)) {
        setValidation(false);
        return;
      }
      if (
        occupation.sourceOfFunds.Others2 &&
        occupation.sourceOfFundsOthersContent === ""
      ) {
        setValidation(false);
        return;
      }
      setValidation(true);
      return;
    } else {
      //set the next button disable state as true
      if (!validataion) setValidation(false);
    }
  }, [occupation]);

    //AA on load
    useEffect(()=>{
    if (!isMailingAddressUpdated) return;

      trackOnLoad()
    },[])

  if (!isMailingAddressUpdated) {
    history.push(ROUTE_PATH.EVER_GREEN_MAILING_ADDRESS);
    return <></>;
  }
  return (
    <MainContainer
      backButtonPath={ROUTE_PATH.EVER_GREEN_MAILING_ADDRESS}
      step={3}
    >
      <Header>
        <Title align="center" variant="title">
          Let's understand your employment and income
        </Title>
        <div style={{ marginTop: "16px" }}>
          <Title variant="description" align="center" fontWeight={600}>
            This will help us determine if you're suitable for the product.
          </Title>
        </div>
      </Header>
      <InnerContainer className={marginTopStyle}>
        <EmploymentDetail />
      </InnerContainer>
      <InnerContainer className={marginTopStyle}>
        <SourceOfWealth />
      </InnerContainer>
      <ButtonStyle>
        <Button
          width="180px"
          theme={EverGreenStyle}
          onClick={() => {
            trackOnFormStartOrSuccess("DS_occupation_form",true)

            history.push(ROUTE_PATH.EVER_GREEN_TAX_DECLARATION);
          }}
          disabled={!validataion}
          label="Next"
        />
      </ButtonStyle>
    </MainContainer>
  );
}

export default Occupation;

const marginTopStyle = css`
  margin-top: 24px;
  div[data-comp="dd"] {
    p {
      font-size: 14px;
    }
  }
`;

const ButtonStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 64px;
`;

const Header = styled.div`
  p:first-child {
    font-size: 18px;
  }

  div:nth-child(2) {
    p {
      font-size: 14px;
      font-weight: 600;
    }
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    p:first-child {
      font-size: 28px;
    }
    div:first-child {
      p {
        font-size: unset;
      }
    }
  }
`;
